// extracted by mini-css-extract-plugin
var _1 = "webpack-components-core-StructuredList-StructuredList-module__list";
export { _1 as "list" }
